import ResponseHandler from "../../rest_client/response_handler";
import { FormAPI } from 'lecom-api';

export default class SubmitErrorResponseHandler {
	static execute(formId, response) {
		SubmitErrorResponseHandler.isValidationErrorResponse(response)
			? SubmitErrorResponseHandler.handleValidationSubmitError(formId, response)
			: displayErrorResponseFlashMessage(response);
	}

	static isValidationErrorResponse(response) {
		const errorStatusCode = response.status ? parseInt(response.status.code) : 500;

		return errorStatusCode == 422
			&& !!response.entity
			&& !!response.entity.errors
			&& response.entity.errors.length > 0
			&& !!response.entity.errors[0].identification;
	}

	static handleValidationSubmitError(formId, response) {		
		const responseErrors = response.entity.errors;
		const formAPI = FormAPI.form(formId);
		let parsedValidationErrors = {};
		responseErrors.forEach((responseError) => {
			let parsedValidationError = parsedValidationErrors[responseError.identification];

			!!parsedValidationError
			? parsedValidationError.push(responseError.message)
			: parsedValidationErrors[responseError.identification] = [responseError.message];
		});

		formAPI.errors(parsedValidationErrors).apply();
	}
}

function displayErrorResponseFlashMessage(response) {		
	const { entity } = response;
	let typeWarning = false;
	
	if (entity.errors && entity.errors.length) {
		let errorFieldSpecial = entity.errors.find(error => error.code === 'value_required');		
		let errorLock = entity.errors.find(error => error.code === 'integration_in_lock');

		if (errorFieldSpecial) {
			response = Realize.i18n.t("form.errors.error_default");
		}
		else if (errorLock)			
			typeWarning = true;	
	}

	if (typeWarning)
		ResponseHandler.displayWarningFlashMessage(Realize.i18n.t(`form.errors.integration_in_lock`), "flash-form");
	else
		ResponseHandler.displayErrorResponseFlashMessage("flash-form", response);
}
